import * as React from 'react';

import { cls } from '@/utils/cls';

export type CardProps = React.HTMLAttributes<HTMLDivElement>;

export function Card({
  className,
  children,
  ...props
}: React.PropsWithChildren<CardProps>): JSX.Element {
  return (
    <div
      className={cls(
        'rounded-xl border border-gray-100 bg-white p-12',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
